import { useEffect, useState } from "react";
import { toast } from "sonner";
import { errMsg, useApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import EmailDeliveryState from "../EmailDeliveryState";

const EMAIL = /^[^@\s]{1,64}@[^@\s]{1,190}\.[a-z]{2,24}$/i;
const split = (v) => v.split(/[,;\s]+/).map((x) => x.trim()).filter(Boolean);

// Team alert for every new booking: in-app notice and team email are two separate settings (own permission, not the «operations» lock).
export default function BookingTeamAlert({ tid }) {
  const api = useApi();
  const [s, setS] = useState(null);
  const [emails, setEmails] = useState("");
  const [busy, setBusy] = useState(false);
  const take = (data) => { setS(data); setEmails((data.notify_emails || []).join(", ")); };
  useEffect(() => { api.get(`/t/${tid}/booking/notify`).then(({ data }) => take(data)).catch(() => setS(false)); }, [api, tid]);
  if (!s) return null;
  const list = split(emails);
  const bad = list.filter((e) => !EMAIL.test(e));
  const err = s.notify_email_enabled && (bad.length ? `Indirizzo non valido: ${bad.join(", ")}` : !list.length ? "Indica almeno un indirizzo" : list.length > 5 ? "Massimo 5 indirizzi" : "");
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put(`/t/${tid}/booking/notify`, { notify_in_app: s.notify_in_app, notify_email_enabled: s.notify_email_enabled, notify_emails: s.notify_email_enabled ? list : [] });
      take(data); toast.success("Avvisi al team salvati");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const ro = !s.can_edit;
  return (
    <section className="space-y-3 rounded-xl border border-slate-200 bg-white p-4" data-testid="calendar-team-alert" aria-labelledby="team-alert-title">
      <p id="team-alert-title" className="text-sm font-medium text-slate-800">Avviso al team per ogni nuova prenotazione</p>
      <label className="flex items-center gap-2 text-sm text-slate-700"><Switch checked={s.notify_in_app !== false} onCheckedChange={(v) => setS({ ...s, notify_in_app: v })} disabled={ro} data-testid="calendar-notify-inapp" />Notifica nell'area clienti</label>
      <label className="flex items-center gap-2 text-sm text-slate-700"><Switch checked={!!s.notify_email_enabled} onCheckedChange={(v) => setS({ ...s, notify_email_enabled: v })} disabled={ro} data-testid="calendar-notify-email-enabled" />Invia email al team</label>
      {s.notify_email_enabled && (
        <div className="space-y-1">
          <Label htmlFor="team-alert-emails" className="text-xs text-slate-600">Email del team (fino a 5, separate da virgola)</Label>
          <Input id="team-alert-emails" type="text" inputMode="email" value={emails} onChange={(e) => setEmails(e.target.value)} placeholder="team@tuaattivita.it" disabled={ro}
            aria-invalid={!!err} className="h-9 w-full max-w-md" data-testid="calendar-notify-email" />
          {err && <p className="text-xs text-red-600" role="alert" data-testid="calendar-notify-email-error">{err}</p>}
        </div>)}
      {!ro && <Button size="sm" onClick={save} disabled={busy || !!err} data-testid="calendar-notify-save">Salva</Button>}
      {ro && <p className="text-xs text-slate-500" data-testid="calendar-notify-readonly">Solo titolare e responsabili possono cambiare questi avvisi.</p>}
      {s.notify_email_enabled && <EmailDeliveryState d={s.delivery} testid="calendar-notify-delivery" />}
    </section>);
}
